export enum PayServiceTypeEnum {
    None = 0,
    PayMaya = 1,
    CreditCard = 2,
    XpressWallet = 3,
    GCash = 4,
    BaUbp = 5,
    BaBpi = 6,
    BaCb = 7,
    BaPnb = 8,
    BaEwb = 9,
    Cash = 10,
    ForCompany = 11
}
